import { call, put, takeEvery } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import AddLoanExpense from "Communication/ApiClasses/AddLoanExpenseRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleAddLoanExpense(action) {
  yield put(doLoadingStart(STRINGS.EXPENSE.API_KEYS.LOAN_ADD_EXPENSE));
  const addLoanExpense = new AddLoanExpense(
    action.data.applicantId,
    action.data.finAnalysisId,
    action.data.payLoad
  );
  try {
    const result = yield call(addLoanExpense.getData);
    yield put({
      type: actionTypes.LOAN_ADD_EXPENSE_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_ADD_EXPENSE_ERROR,
      error: e.message,
    });
  } finally {
    yield put(doLoadingFinish(STRINGS.EXPENSE.API_KEYS.LOAN_ADD_EXPENSE));
  }
}

// watcher
function* addLoanExpenseWatcherSaga() {
  yield takeEvery(actionTypes.LOAN_ADD_EXPENSE, handleAddLoanExpense);
}

export default addLoanExpenseWatcherSaga;
